export default "__VITE_ASSET__DKCpGD4M__"